import { render } from "./pageType4.vue?vue&type=template&id=61d33d3d&scoped=true"
import script from "./pageType4.vue?vue&type=script&lang=js"
export * from "./pageType4.vue?vue&type=script&lang=js"

import "./pageType4.vue?vue&type=style&index=0&id=61d33d3d&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d33d3d"]])

export default __exports__